import { animate, state, style, transition, trigger } from '@angular/animations';
import { CdkAccordionItem } from '@angular/cdk/accordion';
import { Component, Input, OnChanges } from '@angular/core';
import { MatExpansionPanelState } from '@angular/material/expansion';

const bodyExpansion = trigger('bodyExpansion', [
    state('collapsed, void', style({ height: '0px', visibility: 'hidden' })),
    state('expanded', style({ height: '*', visibility: 'visible' })),
    transition('expanded <=> collapsed, void => collapsed', animate('225ms cubic-bezier(0.4, 0, 0.2, 1)')),
]);

/** An notification block that functions as and extends CDK's expandable functionality.  */
@Component({
    selector: 'of-notice-inline',
    templateUrl: './notice-inline.component.html',
    styleUrls: ['./notice-inline.component.scss'],
    animations: [bodyExpansion],
    standalone: false
})
export class NgxNoticeInlineComponent extends CdkAccordionItem {
    /** The title that will appear at the top of the notification. */
    @Input() titleText = '';
    /** The url of the image that will appear on the side of the notification. */
    @Input() srcUrl = '';
    /** The alt text for the image on the side of the notification. */
    @Input() altText = '';

    /** Expand the component in to an open state. */
    open () {
        if (this.expanded) {
            // Add a --needs-attention class
        } else {
            super.open();
        }
    }

    /** Return `expanded` or `collapsed` depending on the expandable status. */
    getExpandedState (): MatExpansionPanelState {
        return this.expanded ? 'expanded' : 'collapsed';
    }
}
